import { render, staticRenderFns } from "./voicemail-sms.vue?vue&type=template&id=1943c01c"
import script from "./voicemail-sms.vue?vue&type=script&lang=js"
export * from "./voicemail-sms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports